import * as pinia from 'pinia';
import { useLocalStorage } from '@vueuse/core';

const useBandwidthControlStore = pinia.defineStore('BandwidthControlStore', {
  state: () => ({
    isModalOpen: false,
    streamPreferences: useLocalStorage('_vice:bandwidthControl', {}),
  }),

  getters: {
    // Get enabled streams for current session
    enabledStreamsForSession: (state) => (sessionId) => state.streamPreferences[sessionId] || {},

    // Check if a specific stream is enabled
    isStreamEnabled: (state) => (sessionId, jitsiUserId) => {
      const sessionPrefs = state.streamPreferences[sessionId];
      // Default to enabled if not set
      return sessionPrefs?.[jitsiUserId] !== false;
    },
  },

  actions: {
    openModal() {
      this.isModalOpen = true;
    },

    closeModal() {
      this.isModalOpen = false;
    },

    // Toggle stream on/off
    toggleStream(sessionId, jitsiUserId) {
      if (!this.streamPreferences[sessionId]) {
        this.streamPreferences[sessionId] = {};
      }

      const currentState = this.streamPreferences[sessionId][jitsiUserId];
      this.streamPreferences[sessionId][jitsiUserId] = currentState === false;
    },

    // Initialize all streams as enabled for a session
    initializeSession(sessionId, streamIds) {
      if (!this.streamPreferences[sessionId]) {
        this.streamPreferences[sessionId] = {};
        streamIds.forEach((id) => {
          this.streamPreferences[sessionId][id] = true;
        });
      }
    },

    // Clean up old sessions
    cleanupOldSessions(currentSessionId) {
      const keys = Object.keys(this.streamPreferences);
      keys.forEach((key) => {
        if (key !== currentSessionId) {
          delete this.streamPreferences[key];
        }
      });
    },
  },
});

export default useBandwidthControlStore;
